{
  "name": "aat-project",
  "version": "1.3.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -o",
    "build-dev": "ng build --configuration=development",
    "build-prod": "ng build",
    "not-used-copy-dev": "node transfer.js dev",
    "not-used-copy-prod": "node transfer.js prod",
    "lint": "ng lint",
    "copy-test-local": "node transfer-local.js test",
    "copy-prod-local": "node transfer-local.js prod"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.18",
    "@angular/common": "^20.3.18",
    "@angular/compiler": "^20.3.18",
    "@angular/core": "^20.3.18",
    "@angular/forms": "^20.3.18",
    "@angular/platform-browser": "^20.3.18",
    "@angular/platform-browser-dynamic": "^20.3.18",
    "@angular/router": "^20.3.18",
    "@azure/msal-angular": "^5.1.3",
    "@azure/msal-browser": "^5.6.2",
    "@fortawesome/fontawesome-free": "^7.2.0",
    "bootstrap": "^5.3.8",
    "moment": "^2.30.1",
    "ngx-bootstrap": "^20.0.0",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.1",
    "sweetalert2": "^11.22.2",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.22",
    "@angular/cli": "~20.3.22",
    "@angular/compiler-cli": "^20.3.18",
    "@types/node": "^22.16.2",
    "node-ssh": "^13.2.1",
    "typescript": "~5.9.2",
    "zip-a-folder": "^3.1.9"
  }
}
